<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.feedbackManager") }}</h4>
    </div>
    <div class="wrap_con type_bt_wrap">
      <div class="p-2" style="text-align: right">
        <button type="button" @click="addMember" class="btn btn-primary btn-md m-2">
          {{ $t("common.add") }}
        </button>
        <button type="button" @click="saveNewMem" class="btn btn-primary btn-md">
          {{ $t("common.save") }}
        </button>
      </div>
      <div>
        <table class="list_tbl">
          <thead>
            <tr>
              <th class="mobile_row">{{ $t("signup.name") }}</th>
              <th class="mobile_h">{{ $t("signup.userId") }}</th>
              <th class="mobile_h">{{ $t("signup.compName") }}</th>
              <th class="mobile_h">{{ $t("signup.email") }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="managers.length != 0">
            <tr v-for="(mem, index) in managers" :key="index">
              <td :id="mem.userId">{{ mem.userName }}</td>
              <td>{{ mem.loginId }}</td>
              <td>{{ mem.compName }}</td>
              <td>{{ mem.emailAddress }}</td>
              <td>
                <button
                  type="button"
                  @click="deleteFeedbackManager(mem, index)"
                  class="btn btn-secondary btn-sm"
                >
                  {{ $t("common.delete") }}
                </button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5">{{ $t("common.noData") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <CommonModal id="memModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("management.addManager") }}</h3>
      </template>
      <template slot="body">
        <div class="list_top_box">
          <div class="float-end">
            <div class="list_top_search d-flex">
              <select
                class="int_type01"
                v-model="form.searchType"
                aria-label="sort select"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option value="loginId">{{ $t("management.id") }}</option>
                <option value="userName">{{ $t("common.name") }}</option>
              </select>
              <input
                type="text"
                v-model="form.searchWord"
                name="userName"
                class="m-1 form-control"
              />
              <a
                id="btnSearch"
                @click="searchBtn"
                href="#"
                class="btn btn-primary btn-lg"
                >{{ $t("common.search") }}</a
              >
            </div>
          </div>
        </div>
        <table class="list_tbl inner_tb">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  @click="goCheckAll($event.target.checked)"
                  class="form-check-input"
                  v-model="checkAll"
                />
              </th>
              <th class="mobile_h">{{ $t("management.id") }}</th>
              <th class="mobile_h">{{ $t("signup.name") }}</th>
              <th class="mobile_h">{{ $t("signup.email") }}</th>
              <th class="mobile_h">{{ $t("management.telNumber") }}</th>
            </tr>
          </thead>
          <tbody v-if="mgmtUser.length != 0">
            <tr v-for="(mem, index) in mgmtUser" :key="index">
              <td>
                <input type="checkbox" v-model="mem.selected" class="form-check-input" />
              </td>
              <td>{{ mem.loginId }}</td>
              <td>{{ mem.userName }}</td>
              <td>{{ mem.emailAddress }}</td>
              <td>{{ mem.mobileTelNo }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4">{{ $t("common.noData") }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="mgmtUser.length != 0" class="paging_nav">
          <div class="paging_nav">
            <a
              href="#"
              v-if="pagingVO.startPage <= pagingVO.blockSize"
              class="page_select prev_page disabled"
              >이전페이지 이동</a
            >
            <a
              v-else
              class="page_select prev_page"
              @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
              v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
              >이전페이지 이동</a
            >
            <span
              v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
              :key="index"
            >
              <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
                pagingVO.startPage + index
              }}</strong>
              <a href="#" v-else @click="searchPage(pagingVO.startPage + index)">{{
                pagingVO.startPage + index
              }}</a>
            </span>
            <a
              v-if="pagingVO.endPage >= pagingVO.totalPage"
              href="#"
              class="page_select next_page disabled"
              >다음페이지 이동</a
            >
            <a
              v-else
              href="#"
              @click="searchPage(pagingVO.endPage + 1)"
              v-bind:data-page="pagingVO.endPage + 1"
              class="page_select next_page"
              >다음페이지 이동</a
            >
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getSelected" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
  </section>
</template>

<script>
import $ from "jquery";
import { getFeedbackManager, saveFeedbackManager } from "@/api/feedback";
import { getMgmtUser } from "@/api/user";
import CommonModal from "@/components/modal/CommonModal";
export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      managers: [],
      form: {
        searchType: "",
        searchWord: "",
        page: 1,
      },
      pagingVO: "",
      mgmtUser: "",
      checkAll: false,
      showModal: false,
    };
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getFeedbackManager();
        this.managers = data.memList;
      } catch (error) {
        console.log(error);
      }
    },
    // 관리자 검색 모달 show
    async addMember() {
      this.showModal = true;
      try {
        const { data } = await getMgmtUser(this.form);
        this.mgmtUser = data.pagingVO.dataList;
        this.pagingVO = data.pagingVO;
      } catch (err) {
        console.log(err);
      }
    },
    // 선택한 관지라 추가
    getSelected() {
      for (let i in this.mgmtUser) {
        if (this.mgmtUser[i].selected) {
          this.mgmtUser[i].crudType = "I";
          this.managers.push(this.mgmtUser[i]);
        }
      }
      this.showModal = false;
    },
    closeModal() {
      this.showModal = false;
    },
    // 전체선택
    goCheckAll(checked) {
      this.checkAll = checked;
      for (let i in this.mgmtUser) {
        this.mgmtUser[i].selected = this.checkAll;
      }
    },
    // 관리자 검색
    searchBtn() {
      this.form.page = 1;
      this.addMember();
    },
    // 페이지 클릭 시
    searchPage(page) {
      this.form.page = page;
      this.addMember();
    },
    async saveNewMem() {
      try {
        const { data } = await saveFeedbackManager(this.managers);
        if (data.status) {
          this.showModal = false;
          alert(this.$t("alert.changedSuccessfully"));
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    deleteFeedbackManager(mem, index) {
      $("#" + mem.userId)
        .closest("tr")
        .hide();
      this.managers[index].crudType = "D";
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style></style>
